import apiClient from "../api/apiClient";
import { StorageKeys } from "../constants/localStorage";

export type OnboardingStep =
  | "otp"
  | "info"
  | "services"
  | "authorize"
  | "slots";

export interface OnboardingDraftPrefillService {
  id: number;
  description: string;
  duration: number;
  price: string;
  cancellation_policy: number;
  show_without_price: boolean;
}

export interface OnboardingDraftPrefill {
  id: string;
  phone: string;
  owner_name: string | null;
  business_name: string | null;
  category: string | null;
  email: string | null;
  services: OnboardingDraftPrefillService[];
}

export type OnboardingState =
  | { status: "none" }
  | { status: "complete"; business_id: string }
  | {
      status: "draft";
      last_completed_step: OnboardingStep | null;
      prefill: OnboardingDraftPrefill;
    };

export interface SaveDraftPayload {
  last_completed_step: OnboardingStep;
  fields: Record<string, unknown>;
  services?: unknown[];
}

const headers = {
  "x-token-type": StorageKeys.VerifiedBusinessOtpToken as string,
};

class OnboardingService {
  async fetchOnboardingState(): Promise<OnboardingState> {
    const { data } = await apiClient.get<OnboardingState>(
      "/api/business/onboarding/current",
      { headers },
    );
    return data;
  }

  async saveDraft(payload: SaveDraftPayload): Promise<{ id: string }> {
    const { data } = await apiClient.patch<{ id: string }>(
      "/api/business/onboarding/draft",
      payload,
      { headers },
    );
    return data;
  }
}

export const onboardingService = new OnboardingService();
